module.exports = __webpack_public_path__ + "img/ehealth-logo.378fdaf2.png";